import {Button, ButtonLayout, Dialog, Illustration, Stack, Text} from "@mbank-design/design-system/components";
import {WebPageSecurityCorporate} from "@mbank-design/design-system/illustrations";


export enum SendConfirmationSendStatus
{
    Cancel = 1,
    Send = 2
}

interface SendConfirmationProps {
    isOpen: boolean,
    onClose: ((status: SendConfirmationSendStatus) => void)
}

export default function ConfirmSending({isOpen, onClose}: SendConfirmationProps) {
    
    return (
        <Dialog isOpen={isOpen} closeButtonAccessibilityLabel={"Close dialog"}>
            <Dialog.Header>
                <Stack>
                    <Illustration illustrationComponent={WebPageSecurityCorporate} />
                    <Text as={"h2"}>are you sure you want to send this form?</Text>
                </Stack>
            </Dialog.Header>
            
            <Dialog.Content>
                <Text as={"body"}>it will not be possible to perform this action again</Text>
            </Dialog.Content>
            
            <Dialog.Actions>
                <ButtonLayout direction="column" isFullWidth={false}>
                    <Button buttonType={"secondary"} onClick={() => onClose(SendConfirmationSendStatus.Cancel)}>Cancel</Button>
                    <Button buttonType={"primary"} onClick={() => onClose(SendConfirmationSendStatus.Send)}>Send</Button>    
                </ButtonLayout>
            </Dialog.Actions>
        </Dialog>
    );
}